import type { paths } from '@pba/types-openapi-node';
import type { BodyRouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

type NodeEventUserStatusBodyRequestParams =
  paths['/events/{eventId}/participants/rsvp']['post']['requestBody']['content']['application/json'];
type NodeEventUserStatusPathRequestParams = paths['/events/{eventId}/participants/rsvp']['post']['parameters']['path'];

export const updateNodeEventUserStatus = async ({
  body,
  routeParams: { eventId },
}: BodyRouteParamsRequest<NodeEventUserStatusBodyRequestParams, NodeEventUserStatusPathRequestParams>) =>
  nodeApiClient.post<undefined, ApiClientResponse<undefined>>(nodeApiRoutes.events.participants.rsvp(eventId), body);
